import AppBar from '@mui/material/AppBar';
import React, {useEffect} from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import '../../App.css';
import {logout} from '../../api/auth';
import logoIcon from '../../assets/bimi/logo-icon.svg';
import {useAddepar} from '../../hooks/use-adepar';
import {useAuth} from '../../hooks/use-auth';
import {useBill} from '../../hooks/use-bill';
import {useBridge} from '../../hooks/use-bridge';
import {usePlaid} from '../../hooks/use-plaid';
import {useRamp} from '../../hooks/use-ramp';

function Navbar({user, children}) {
  const {
    state: {profile},
    getProfile,
  } = useAuth();
  const {fetchInitialFromDB} = usePlaid();
  const {fetchInitialBill} = useBill();
  const {fetchInitialAddepar} = useAddepar();
  const {fetchInitialBridge} = useBridge();
  const {fetchInitialRamp} = useRamp();

  const admin = !!profile.admin;

  useEffect(() => {
    if (user?.uid) {
      // ONLY PULL CURRENT USER INFO IF NOT ADMIN
      if (!admin) {
        fetchInitialFromDB(user.uid);
        fetchInitialBill(user.uid);
        fetchInitialAddepar(user.uid);
        fetchInitialBridge(user.uid);
        fetchInitialRamp(user.uid);
      }
      getProfile(user.uid);
    }
  }, [user?.uid]);

  return (
    <div>
      <AppBar position="static" sx={{backgroundColor: '#f6f6f6'}}>
        <div className="flex-row justify-between align-center">
          <div className="brand-logo">
            <img alt="Forest Connect" className="brand-logo-icon" src={logoIcon} />
            <span className="brand-logo-text">
              <span className="brand-logo-text-forest">Forest</span>
              <span className="brand-logo-text-connect">Connect</span>
            </span>
          </div>
          {user ? admin ? <AdminBar /> : <UserBar /> : null}
        </div>
      </AppBar>
      {children || <Outlet />}
    </div>
  );
}

const AdminBar = () => {
  const {reset} = useAuth();
  const {resetPlaid} = usePlaid();
  const navigate = useNavigate();

  const logOut = async () => {
    await logout();
    reset();
    resetPlaid();
    navigate('/');
  };

  return (
    <div className="flex-row">
      <button
        className="gray-button"
        onClick={() => {
          navigate('/admin/user/dashboard');
        }}>
        Users
      </button>
      <button
        className="gray-button"
        onClick={() => {
          navigate('/admin/client/dashboard');
        }}>
        Clients
      </button>
      <button className="gray-button" onClick={logOut}>
        Log out
      </button>
    </div>
  );
};

const UserBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const logOut = async () => {
    await logout();
    navigate('/');
  };

  const onAddConnectionPage = location.pathname === '/add-connection';

  return (
    <div className="flex-row">
      <button
        className="green-button"
        onClick={() =>
          navigate(onAddConnectionPage ? '/dashboard' : '/add-connection')
        }>
        {onAddConnectionPage ? 'Current Connections' : 'Add Connection'}
      </button>
      <button className="gray-button" onClick={logOut}>
        Log out
      </button>
    </div>
  );
};

export default Navbar;
